module.exports = __webpack_public_path__ + "static/media/embedded-ai-workflow.2b4f2453.jpg";